
import { GetterTree } from 'vuex';
import { TrainerPaymentState } from './types';
import { RootState } from '../../types';

export const getters: GetterTree<TrainerPaymentState, RootState> = {
  ['getTrainerPayments']: (state) => state.trainerPayments,
  ['getTrainerPaymentsIsLoading']: (state) => state.trainerPayments?.isLoading,
  ['getTrainerPaymentsTotal']: (state) => state.trainerPayments?.total,
  ['getTrainerPaymentsSearchParams']: (state) => state.trainerPayments?.searchParams,
};
